module.exports = __webpack_public_path__ + "img/logo.c7e445b.png";